<template>
  <div class="shopping">
    <div class="pao pao1 wow"></div>
    <img src="@/assets/catering3_enter.png" class="pao pao3 wow slideInLeftSelf">
    <img src="@/assets/catering4_enter.png" class="pao pao2 wow fadeIn">
    <div class="pao pao5 wow slideInLeftSelf"></div>
    <!-- <div class="pao pao4 wow slideInRightSelf"></div> -->
    <div class="pao pao6 wow"></div>
    <div class="pao pao7 wow slideInLeftSelf"></div>
    <myMenu :type="2" @zoomChange="initWow"></myMenu>
    <div class="shopping_content">
      <div class="linear_word">ENTERTAINMENT</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">休闲娱乐</div>
      </div>
      <drop class="drop1" cssVal=" right: -22px;top: 503px;" :size="4"></drop>
      <div class="block block_left">
        <div class="block_text">
          <div class="title title1">
            <div>
              <span class="title_span title1_span wow slideInLeftSelf">熊熊乐园</span>
            </div>
          </div>
          <div class="dec dec1 wow" data-wow-offset="-100000">《熊熊乐园》是以“熊出没”为主题打造的室内儿童探险乐园，让小朋友在“熊出没”的世界中尽情玩乐，收获勇气和快乐。  </div>
        </div>
        <div class="pic pic1 wow" data-wow-offset="-100000"></div>
      </div>

      <drop class="drop2" cssVal="left: 0px;top: 835px;" :size="8"></drop>
      <div class="block block_right">
        <div class="pic pic2 wow" data-wow-offset="-100000"></div>
        <div class="block_text">
          <div class="title title2">
            <div>
              <span class="title_span title2_span wow slideInLeftSelf">潮玩馆</span>
            </div>
          </div>
          <div class="dec dec2 wow" data-wow-offset="-100000">电玩城配备多种潮流游戏，满足游客的娱乐需求，为您提供一个舒适时尚的娱乐场所。 </div>
        </div>
      </div>
      <drop class="drop2" cssVal="right: -34px;top: 1645px;" :size="8"></drop>
      <div class="block block_left">
        <div class="block_text">
          <div class="title title1">
            <div>
              <span class="title_span title1_span wow slideInLeftSelf">熊熊小火车博物馆</span>
            </div>
          </div>
          <div class="dec dec1 wow" data-wow-offset="-100000">呜——呜——和熊大熊二一起乘坐蒸汽小火车，踏上熊湾的奇幻探险之旅。</div>
        </div>
        <div class="pic pic1 pic4 wow" data-wow-offset="-100000"></div>
      </div>

      <drop class="drop2" cssVal="left: -5px;top: 2286px;" :size="5"></drop>
      <div class="block block_right">
        <div class="pic pic2 pic5 wow" data-wow-offset="-100000"></div>
        <div class="block_text">
          <div class="title title2">
            <div>
              <span class="title_span title2_span wow slideInLeftSelf">港湾影城</span>
            </div>
            <div class="dec dec2 wow" data-wow-offset="-100000">《港湾影城》以“熊出没”主题包装的影院，让游客重温有熊出没陪伴的美好时光。</div>
          </div>
        </div>
      </div>
      <drop class="drop2" cssVal="right: -23px;top: 2901px;" :size="5"></drop>
      <div class="block block_left">
        <div class="block_text">
          <div class="title title2">
            <div>
              <span class="title_span title2_span wow slideInLeftSelf">飞行家挑战基地</span>
            </div>
            <div class="dec dec1 wow" data-wow-offset="-100000">《飞行家挑战基地》项目利用空气动力学的原理，让游客体验失重的感觉，感受飞翔的刺激，体会只有万米高空跳伞时才能感受到的空中飞行、自由落体之快感。 </div>
          </div>
        </div>
        <div class="pic pic1 pic6 wow" data-wow-offset="-100000"></div>
      </div>
      <div class="pic pic3 wow fadeInUp">
        <img src="@/assets/entertainment_block6.png">
      </div>
    </div>
    <myBottom></myBottom>
  </div>
</template>

<script>
import myMenu from '@/components/myMenu.vue'
import myBottom from '@/components/myBottom.vue'
import drop from '@/components/drop.vue'

import "wowjs/css/libs/animate.css";
import "@/assets/css/wowExtra.css";
import { WOW } from 'wowjs'

export default {
  components: { myMenu, myBottom, drop },
  data() {
    return {

    }
  },
  methods: {
    setWow() {
      $('.dec1, .pic1, .pao1').css('transform', 'translate(-20000px, 0)');
      $('.dec2, .pic2').css('transform', 'translate(-20000px, 0)');
      $('.drops').css('transform', 'translate(-20000px, 0)');
    },
    initWow(zoom) {
      var top = $('.shopping .pic3').offset().top;
      var offset = zoom >= 1 ? 200 * zoom : (200 * zoom - (top - top * zoom));
      var wow = new WOW(
        {
          animateClass: 'animated',
          offset,
          callback: box => {
            if (box.className.includes('title_span')) {
              var pic = $(box).closest('.block').find('.pic');
              var dec = $(box).closest('.block').find('.dec');
              var drops = $(box).closest('.block').prev('.drops');
              pic.css('transform', 'translate(0, 0)');
              dec.css('transform', 'translate(0, 0)');
              drops.css('transform', 'translate(0, 0)');
              pic.addClass('fadeInDown');
              dec.addClass('fadeInUp');
              drops.find('.drop').addClass('zoomIn');
              $('.pao1').css('transform', 'translate(0, 0)');
              $('.pao1').addClass('slideInRightSelf');
            }
          }
        }
      );
      wow.init();
    },
  },
  mounted() {
    this.setWow();
    var hrefId = this.$route.query.id - 1
    if (this.$route.query.id) {
      $('html').animate({ scrollTop: 0 }, 0)
      var h = $('.block').eq(hrefId).offset().top * document.documentElement.clientWidth / 1920
      setTimeout(() => {
        $('html').animate({ scrollTop: h }, 1000)
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.shopping {
  .shopping_content {
    width: 1320px;
    margin: 110px auto 100px;
    position: relative;
    .title {
      font-size: 36px;
      color: #000;
      font-weight: bold;
      margin-top: 70px;
      &::before {
        content: '';
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #f39f43;
        vertical-align: middle;
        display: inline-block;
        margin-right: 38px;
      }
      > div {
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
      }
      span {
        display: inline-block;
      }
    }
    .title2 {
      // margin-top: 110px;
    }
    .block {
      display: flex;
      margin-bottom: 55px;
    }
    .block_left {
      .block_text {
        margin-right: 103px;
      }
    }
    .block_right {
      .block_text {
        margin-left: 103px;
        margin-right: 0;
      }
    }
    .dec {
      font-size: 26px;
      font-family: SourceHanSansCN;
      font-weight: 400;
      color: #1e1e1e;
      line-height: 50px;
      margin-top: 30px;
      // letter-spacing: 2px;
      text-indent: 2em;
    }
    .dec1 {
      // width: 1020px;
    }
    .pic {
      border-radius: 20px;
      margin-top: 120px;
    }
    .pic1 {
      border: 1px solid #fff;
      background-color: rgb(182, 188, 203);
      box-shadow: 0px 3px 24px 0px rgba(69, 86, 131, 0.4);
      width: 756px;
      height: 434px;
      background: url('@/assets/entertainment_block1.png') no-repeat center;
      background-size: cover;
      // margin: 0 auto;
      flex-shrink: 0;
      margin-right: 88px;
    }
    .pic2 {
      border: 1px solid #fff;
      background-color: rgb(182, 188, 203);
      box-shadow: 0px 3px 24px 0px rgba(69, 86, 131, 0.4);
      width: 689px;
      height: 444px;
      background: url('@/assets/entertainment_block2.png') no-repeat center;
      background-size: cover;
      // margin: 0 auto;
      flex-shrink: 0;
      margin-left: 50px;
    }
    .pic4 {
      width: 754px;
      height: 452px;
      background: url('@/assets/entertainment_block3.png') no-repeat center;
    }
    .pic5 {
      width: 690px;
      height: 443px;
      background: url('@/assets/entertainment_block4.png') no-repeat center;
    }
    .pic6 {
      width: 754px;
      height: 452px;
      background: url('@/assets/entertainment_block5.png') no-repeat center;
    }
    .pic3 {
      background-color: rgb(255, 255, 255);
      box-shadow: 0px 8px 54px 0px rgba(111, 159, 227, 0.3);
      padding: 50px 0;
      font-size: 0;
      margin-top: 400px;
      display: flex;
      justify-content: center;
    }
  }
  .pao1 {
    border-radius: 50%;
    background-image: url('../assets/catering1_enter.png');
    background-size: contain;
    position: absolute;
    left: 389px;
    top: 384px;
    width: 693px;
    height: 694px;
  }
  .pao2 {
    width: 100%;
    left: 0;
    top: 3484px;
  }
  .pao3 {
    left: 70px;
    top: 3528px;
  }
  .pao5 {
    border-radius: 50%;
    background-image: -moz-linear-gradient(
      -20deg,
      rgb(184, 242, 211) 13%,
      rgb(254, 253, 168) 100%
    );
    background-image: -webkit-linear-gradient(
      -20deg,
      rgb(184, 242, 211) 13%,
      rgb(254, 253, 168) 100%
    );
    background-image: -ms-linear-gradient(
      -20deg,
      rgb(184, 242, 211) 13%,
      rgb(254, 253, 168) 100%
    );
    background-image: linear-gradient(
      -20deg,
      rgb(184, 242, 211) 13%,
      rgb(254, 253, 168) 100%
    );
    position: absolute;
    right: -50px;
    top: 4286px;
    width: 208px;
    height: 208px;
  }
  .pao4 {
    border-radius: 50%;
    background-image: -moz-linear-gradient(
      -20deg,
      #fff6b999 0%,
      #ff983599 100%
    );
    background-image: -webkit-linear-gradient(
      -20deg,
      #fff6b999 0%,
      #ff983599 100%
    );
    background-image: -ms-linear-gradient(-20deg, #fff6b999 0%, #ff983599 100%);
    background-image: linear-gradient(-20deg, #fff6b999 0%, #ff983599 100%);
    opacity: 0.6;
    right: 396px;
    top: 2730px;
    width: 160px;
    height: 160px;
  }
  .pao6 {
    background-image: url('../assets/catering6_enter.png');
    background-size: contain;
    position: absolute;
    left: 508px;
    top: 1639px;
    width: 693px;
    height: 694px;
  }
  .pao7 {
    border-radius: 50%;
    background-image: -moz-linear-gradient(
      71deg,
      rgb(255, 246, 185) 0%,
      rgb(255, 152, 53) 95%
    );
    background-image: -webkit-linear-gradient(
      71deg,
      rgb(255, 246, 185) 0%,
      rgb(255, 152, 53) 95%
    );
    background-image: -ms-linear-gradient(
      71deg,
      rgb(255, 246, 185) 0%,
      rgb(255, 152, 53) 95%
    );
    background-image: linear-gradient(
      71deg,
      rgb(255, 246, 185) 0%,
      rgb(255, 152, 53) 95%
    );
    opacity: 0.702;
    position: absolute;
    left: -217px;
    top: 1389px;
    width: 285px;
    height: 286px;
    z-index: 152;
  }
}
</style>